export const Strings = {
  requiresActionMsg:
    'Please check in orders and verify your bank account to ensure successful payment.',
  verifyPending: 'Verification Pending',
  requires_action: 'requires_action',
  succeeded: 'succeeded',
  requires_payment_method: 'requires_payment_method',
  subscriptionSuccess: 'Subscription created successfully',
  subscriptionCharged: 'Subscription charged successfully',
  updatePayMethod: 'Payment Method updated successfully',
  cancel: 'cancel',
  paymentMethod: 'paymentMethod',
  resume: 'resume',
  pause: 'pause',
  subscription: 'subscription',
  updateFailed: 'Update Failed',
  startSub: 'Start Subscription',
  updateMethod: 'Update Payment Method',
  subPending: 'Subscription Pending',
  payPending: 'payment pending',
  went_wrong: 'Something Went Wrong',
  cancel_pay_process: 'Payment processing cancelled by user',
  cancel_sub_process: 'Subscription processing cancelled by user',
  check_latest_status: 'Please check in orders to ensure updated status.',
  initialized: 'INITIALIZED',
  active: 'ACTIVE',
  cashfree: "cashfree",
  razorpay: "razorpay",
  bank_approval_pending: 'BANK_APPROVAL_PENDING',
  fail: 'fail'
}
